import { RouterModule, Routes } from '@angular/router';

import { BDCPBookmarksDetailsComponent } from './pages/details/details.page';
import { BDCPBookmarksRootComponent } from './pages/root/root.page';
import { NgModule } from '@angular/core';

export const BDCPBookmarksRoutes: Routes = [
    {
        path: '',
        component: BDCPBookmarksRootComponent
    },
    {
        path: 'details/:folderId',
        component: BDCPBookmarksDetailsComponent
    },
    {
        path: '**',
        pathMatch: 'full',
        redirectTo: ''
    }
];

@NgModule({
    imports: [RouterModule.forChild(BDCPBookmarksRoutes)],
    exports: [RouterModule]
})
export class BDCPBookmarksRoutingModule { }
